// @ts-nocheck
/* eslint-disable */
export const keyboardDoubleArrowDownIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="M480-200 240-440l42-42 198 198 198-198 42 42-240 240Zm0-253L240-693l42-42 198 198 198-198 42 42-240 240Z"/></svg>`,
    name: 'keyboard-double-arrow-down' as const
};